import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { Main } from "../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Slide, toast, ToastContainer } from "react-toastify";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { Textarea } from "../../../../themes/Default/components/Form/components/Textarea";
import { useUserToken } from "../../../../hooks/core/UserToken";
import { roles } from "../../../../services/utils/Roles";
import { employeeWeeklyReportManagement } from "../../../../hooks/api/EmployeeWeeklyReportManagement";
import { Title } from "../../../../themes/Default/components/Title";

const EditWeeklyReportNote = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { weeklyReportNoteId } = useParams();
    const { employeeWeeklyReport } = useParams();
    const [report, setReport] = useState(null)

    const {
        useUpdateEmployeeWeeklyReportNoteMutation,
        useViewEmployeeWeeklyReportNoteMutation,
        useViewEmployeeWeeklyReportMutation
    } = employeeWeeklyReportManagement;
    const [editNote] = useUpdateEmployeeWeeklyReportNoteMutation();
    const [viewNote] = useViewEmployeeWeeklyReportNoteMutation();
    const [viewReport] = useViewEmployeeWeeklyReportMutation();

    const tabs = [{ title: t("details"), link: "/settings/reports", isActive: true }];

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        editNote({body, weeklyReportNoteId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                toast.info(result.data.info.responseMessage);
                navigate("/reports/view/" + employeeWeeklyReport + "/notes");
            }
        });
    };


    useEffect(() => {
        viewNote({weeklyReportNoteId}).then((result) => {
            formRef.current.setValues(result?.data);
        });
        viewReport(employeeWeeklyReport).then((result) => {
            setReport(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/reports/view/" + employeeWeeklyReport + "/notes"} />
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{report?.employeeName + " (" + report?.startDateFormated + " - " + report?.endDate + ")"}</Title>
                <Breadcrumps>
                    <Link title={t("report.title")} icon="fa-light fa-clipboard" />
                    <Link title={t("report.view")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        note: "", 
                    }}
                    onSubmit={(values, { resetForm }) => {
                        onSaved(values);
                        resetForm();
                    }}
                >
                    {({ values, handleChange, setFieldValue, resetForm }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea 
                                        name="note" 
                                        label={t('groups.progressNote')} 
                                        rows={5}
                                        value={values.note} 
                                        onChange={handleChange} 
                                        required={true} 
                                        error={formErrors?.note}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditWeeklyReportNote;